var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"conference"}},[_c('div',{staticClass:"container container-one"},[_vm._m(0),_c('div',{staticClass:"list list-one"},[_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'whiteboard',
      subtitle: '',
      title: 'Predavanja',
      description: 'Poslušaj zanimljiva predavanja stručnjaka o aktualnim Dev, Design & Tech temama.'
    }}}),_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'stats',
      subtitle: '',
      title: 'Radionice',
      description: 'Stekni uvid u najnovije tehnologije kroz praktičan rad na radionicama koje vode stručnjaci iz industrije.'
    }}}),_c('Feature',{attrs:{"feature":{
      backgroundColor: '#2C373F',
      icon: 'table',
      subtitle: '',
      title: 'Panel rasprave',
      description: 'U moderiranim raspravama poslušaj različita mišljenja profesionalaca o zanimljivim temama iz svijeta IT-ja.'
    }}})],1)]),_c('img',{staticClass:"visual visual-one",attrs:{"src":require("../../assets/visuals/one.png"),"alt":"Predavanje"}}),_c('div',{staticClass:"black"},[_c('div',{staticClass:"list list-two container"},[_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'tent',
      subtitle: '',
      title: 'Campfire talks',
      description: 'Budi dio “panela u malom” i zajedno sa sponzorima konferencije sudjeluj u raspravama u nesvakidašnjoj atmosferi.'
    }}}),_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'games',
     subtitle: '',
      title: 'Fly talks',
      description: 'Tražiš posao? Kroz kratke jedan na jedan razgovore s poslodavcima saznaj jesi li upravo ti ono što traže.'
    }}})],1)]),_c('img',{staticClass:"visual visual-two",attrs:{"src":require("../../assets/visuals/two.png"),"alt":"Druženje"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"list list-three"},[_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'network',
      subtitle: '',
      title: 'Networking',
      description: 'Kroz opušteni razgovor saznaj sve što te zanima, upoznaj istomišljenike i podijeli svoje interese, iskustva i ideje.'
    }}}),_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'plans',
      subtitle: '',
      title: 'Izložbeni prostor',
      description: 'Sumo borbe, VR, tehnološka alka, craft pivo… Prošetaj štandovima tvrtki i pogledaj što sve imaju za ponuditi.'
    }}}),_c('Feature',{attrs:{"feature":{
      backgroundColor: '#30CEC1',
      icon: 'balloons',
      subtitle: '',
      title: 'Nagrade',
      description: 'Pokaži svoju spretnost u ispunjavanju zadataka i osvoji nagrade poput PlayStationa 4, HTC Vivea i putovanja po Europi.'
    }}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h1',[_vm._v("\n        Dev, Design & Tech\n        "),_c('span',[_vm._v("konferencija")])]),_c('p',[_vm._v("DUMP Days već četvrtu godinu za redom okuplja hrvatsku IT zajednicu i nudi bezbroj prilika za razmjenu znanja i iskustva te stvaranje novih poslovnih veza.")])])}]

export { render, staticRenderFns }